<template>
  <res-select ref="selector" :id="elementId" v-model="selectedProperty" :readonly="readonly" :items="properties" :attach="attachId" :loading="loading" return-object></res-select>
</template>

<script>
  import ResSelect from '@/components/base/ResSelect.vue';
  import propertyService from '@/services/property';

  import { mapActions } from 'vuex'
  import { mapGetters } from 'vuex'

  export default {
    name: 'propertySelector',
    components: {
      ResSelect
    },
    data() {
      return {
        properties: [],
        loading: true
      }
    },
    props: {
      value: {
        required: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      elementId: {
        type: String,
        default: "property-selector"
      },
      includePropertyGroups: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      ...mapActions(['changeSelectedPropertyId']),
      async loadPropertyData() {
        let propertyData = await propertyService.getDropdown(this.includePropertyGroups);
        if (propertyData && propertyData.data) {
          this.properties = propertyData.data;
        } else {
          this.properties = [];
        }
        if (!this.value && this.selectedPropertyId) {
          this.properties.forEach((pr) => {
            if (pr.value == this.selectedPropertyId) {
              this.selectedProperty = { text: pr.text, value: pr.value, header: null, isPropertyGroup: pr.isPropertyGroup };
            }
          })
        }
        this.loading = false;
      },
      selectItem(item) {
        this.$refs.selector.selectItem(item);
      }
    },
    computed: {
      ...mapGetters(['selectedPropertyId']),
      selectedProperty: {
        get () {
          return this.value
        },
        set(newValue) {
          this.$emit("input", newValue)
          if (!newValue.isPropertyGroup) {
            this.changeSelectedPropertyId(newValue.value)
          }
        }
      },
      attachId() {
        return '#' + this.elementId;
      }
    },
    async created() {
      this.$eventHub.$on('replicatedEntitiesSynced', this.loadPropertyData);
    },
    async mounted() {
      this.loadPropertyData();
    }
  }
</script>
